<template>
    <div>
        <!-- Event title -->
        <div v-html="trans(`activities.events.${event}`, { type: item.subject?.taskType?.label, title: item.subject?.title })" />

        <!-- Main title -->
        <div v-if="event === 'quality_assurance_configuration.created'" class="text-small text-muted">
            {{ trans('references.overview.cell.title') }}: {{ item.properties?.title || item.subject?.title }}
        </div>

        <!-- Changes list -->
        <ul v-if="hasChanges" class="list-unstyled text-small mt-2">
            <li v-for="(change, key) in item.properties" :key="key">
                {{ formatKey(key) }}:
                <span class="text-muted"
                    ><span class="line-through">{{ change.old ?? trans('general.not_available') }}</span> → {{ change.new }}</span
                >
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({ item: Object });

// Compute the event string
const event = computed(() => props.item.event);

// Check if there are any changes
const hasChanges = computed(() => {
    if (event.value.indexOf('.created') > -1) return false;
    if (event.value.indexOf('.deleted') > -1) return false;
    return props.item.properties && Object.keys(props.item.properties).length > 0;
});

const keyMap = {
    'config.title': 'quality_assurance.configuration.modal.title_field.label',
    'config.start_date': 'quality_assurance.configuration.modal.start_date.label',
    'config.end_date': 'quality_assurance.configuration.modal.end_date.label',
    'config.recurrence.repeat': 'quality_assurance.configuration.modal.repeat.label',
    'config.recurrence.interval': 'quality_assurance.configuration.modal.repeat.label',
    'config.recurrence.stopCondition': 'general.component.repeat.ends',
    'config.recurrence.count': 'general.component.repeat.ends.after_x_occurrences',
    'config.description': 'quality_assurance.configuration.modal.description.label',
    'config.alert_at': 'quality_assurance.configuration.modal.alert_at.label',
    'config.is_paused': 'quality_assurance.configuration.modal.pause.label',
};

const formatKey = (key) => {
    const value = keyMap[key];
    return value ? trans(value) : key;
};
</script>
